export const actionTypes = {
    SEARCH_STATE_REQUEST: "SEARCH_STATE_REQUEST",
    SEARCH_STATE_SUCCESS: "SEARCH_STATE_SUCCESS",
    SEARCH_STATE_CLEAR: "SEARCH_STATE_CLEAR",

    SEARCH_CLEAR: "SEARCH_CLEAR",
};

export const actionCreators = {
    clear: () => ({
        type: actionTypes.SEARCH_CLEAR,
    }),
    searchRequest: (searchValue: string) => ({
        type: actionTypes.SEARCH_STATE_REQUEST,
        payload: { searchValue },
    }),
    searchSuccess: (foundAuditAssets: Array<any>) => ({
        type: actionTypes.SEARCH_STATE_SUCCESS,
        payload: { foundAuditAssets },
    }),
    clearResults: () => ({
        type: actionTypes.SEARCH_STATE_CLEAR,
    }),
};

export default {
    create: actionCreators,
    type: actionTypes,
};
